import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Customers/customers.html'
})

export class CustomersComponent implements OnInit {

    userDetail: any;
    public constants: Constants;
    public customers: any[] = [];
    public country: any[] = [];
    public customerStatus: any[] = [];
    public filterCustomerStatus: any = "";
    public Search: any = "";
    public addCustomerData: any = { addCustomerCountry: "", addCustomerIsActive: true };
    public editCustomerData: any = { editCustomerCountry: "", editCustomerIsActive: "" };
    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public existsCustomerName: boolean = false;
    public existsCustomerCode:boolean=false;
    public isCustomerFormSubmitted = false;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filterCustomerStatus = this.constants.enumCustomerStatus["Active"];
    }

    newForm() {
       // this.addCustomerData.addCustomerIsActive = false;
        setTimeout(() => this.addCustomerData.addCustomerIsActive = true, 0);
    }

    ngOnInit() {
        this.getCountry();
        this.getStatus();
        this.getCustomers();
    }

    ExportItems() {
        ExportToExcel(this.customers, "Customers",
            ["Customer_Name","CustomerCode", "ContactPerson", "CountryName", "StatusName"],
            ["Customer Name", "ustomer Code","Contact Person", "Country Name", "Status"]);
    }

    ngAfterViewInit() {
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public ResetCustomerForm(form: any) {
        form.reset();
        form.resetForm();
        this.isCustomerFormSubmitted = false;
        setTimeout(() => this.addCustomerData.addCustomerIsActive = true, 0);
    }

    public AddCustomerFormLoad() {
        $('#resetAddCustomerForm').trigger('click');
    }

    public getCountry() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["Country"] }).subscribe(
            data => {
                this.country = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getStatus() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["UserStatus"] }).subscribe(
            data => {
                this.customerStatus = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },

            () => {
                this.showLoader = false;

            }
        );
    }

    public getCustomers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Customer/GetCustomer', { "CustomerId": 0, "CountryId": 0, "CustomerStatus": this.filterCustomerStatus }).subscribe(
            data => {
                this.customers = data["CustomerList"];
             //   console.log(this.customers);

            },
            err => {
                this.showLoader = false;
            },

            () => {
                this.showLoader = false;

            }
        );
    }

    public clearFilter() {
        this.filterCustomerStatus = this.constants.enumCustomerStatus["Active"];
        this.Search = "";
    }

    public CancelAddCustomer(form: any) {
        this.existsCustomerName = false;
        this.existsCustomerCode=false;
        this.addCustomerData = { addCustomerCountry: "", addCustomerIsActive: true };
        this.newForm();
        $('#addCustomer').modal('hide');
        this.isAdd = true;
    }

    public CancelEditCustomer() {
        this.existsCustomerName = false;
        this.existsCustomerCode=false;
        this.editCustomerData = {};
        this.newForm();
        $('#editCustomer').modal('hide');
        this.isAdd = true;
    }

    public AddCustomer(form: any) {
        this.isCustomerFormSubmitted = true;
        if (form.form.valid) {
            this.existsCustomerName = false;
            this.existsCustomerCode=false;
            this.customers.forEach(element => {
                if (element.Customer_Name.trim().toLowerCase() == this.addCustomerData.addCustomerName.trim().toLowerCase()) {
                    this.existsCustomerName = true;
                }
            })
            this.customers.forEach(element => {
                if (element.CustomerCode.trim().toLowerCase() == this.addCustomerData.addCustomerCode.trim().toLowerCase()) {
                    this.existsCustomerCode = true;
                }
            })

            if (!this.existsCustomerName && !this.existsCustomerCode) {
                let objItem: any = {};
                objItem.Customer_Id = 0;
                objItem.Customer_Name = this.addCustomerData.addCustomerName;
                objItem.CountryId = this.addCustomerData.addCustomerCountry;
                objItem.ContactPerson = this.addCustomerData.addCustomerContactPerson;
                objItem.ContactNumber = this.addCustomerData.addCustomerContactNumber;
                objItem.Email = this.addCustomerData.addCustomerEmailId;
                objItem.CustomerCode = this.addCustomerData.addCustomerCode;
                if( objItem.StatusId !=null)
                {
                objItem.StatusId = this.addCustomerData.addCustomerIsActive;
                }
                else 
                {
                     objItem.StatusId = this.addCustomerData.addCustomerIsActive;
                }
                objItem.Modified_By = this.userDetail.SiteUserId;
                this.addEditCustomer(objItem);
                $('#addCustomer').modal('hide');
                this.addCustomerData = { addCustomerCountry: "", addCustomerIsActive: true };
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    public EditCustomers(item: any) {
        $('#resetEditCustomerForm').trigger('click');
        this.isAdd = false;
        this.EditCustomerChange(item.Customer_Id);

    }
    public EditCustomerChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.customers.filter((customer) => customer.Customer_Id == itemId)[0]));
        this.editCustomerData.editCustomerId = objItem.Customer_Id;
        this.editCustomerData.editCustomerName = objItem.Customer_Name;
        this.editCustomerData.editCustomerCode = objItem.CustomerCode;
        this.editCustomerData.editCustomerCountry = objItem.CountryId;
        this.editCustomerData.editCustomerContactPerson = objItem.ContactPerson;
        this.editCustomerData.editCustomerContactNumber = objItem.ContactNumber;
        this.editCustomerData.editCustomerEmailId = objItem.Email;
        this.editCustomerData.editCustomerIsActive = objItem.StatusId;
    }

    public UpdateCustomer(form: any) {
        this.isCustomerFormSubmitted = true;
        if (form.form.valid) {
            this.existsCustomerName = false;
            this.existsCustomerCode=false;
            this.customers.forEach(element => {
                if (element.Customer_Id != this.editCustomerData.editCustomerId && element.Customer_Name.trim().toLowerCase() == this.editCustomerData.editCustomerName.trim().toLowerCase()) {
                    this.existsCustomerName = true;
                }
            });
            this.customers.forEach(element => {
                if (element.Customer_Id != this.editCustomerData.editCustomerId && element.CustomerCode.trim().toLowerCase() == this.editCustomerData.editCustomerCode.trim().toLowerCase()) {
                    this.existsCustomerName = true;
                }
            });

            if (!this.existsCustomerName && !this.existsCustomerCode) {
                let objItem: any = {};
                objItem.Customer_Id = this.editCustomerData.editCustomerId;
                objItem.Customer_Name = this.editCustomerData.editCustomerName;
                objItem.CustomerCode = this.editCustomerData.editCustomerCode;
                objItem.CountryId = this.editCustomerData.editCustomerCountry;
                objItem.ContactPerson = this.editCustomerData.editCustomerContactPerson;
                objItem.ContactNumber = this.editCustomerData.editCustomerContactNumber;
                objItem.Email = this.editCustomerData.editCustomerEmailId;
                objItem.StatusId = this.editCustomerData.editCustomerIsActive;
                objItem.Modified_By = this.userDetail.SiteUserId;
                this.addEditCustomer(objItem);
                $('#editCustomer').modal('hide');
                this.editCustomerData = {};
                this.newForm();
                this.isAdd = true;
            }
        }

    }

    addEditCustomer(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('Customer/AddUpdateCustomer', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getCustomers();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },

            () => {
                this.showLoader = false;

            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Customers/customers.component.ts
 **/